import { SafetyAndSecurityRound } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const SAFETY_AND_SECURITY_ROUND_DATA_TAG = 'SafetyAndSecurityRound';
export default class SafetyAndSecurityRoundParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.AT_SEA_SAFETY_AND_SECURITY, FIXED_PROTOCOL_CONTENT_TYPE_IDS.AT_SEA_SAFETY_AND_SECURITY, SAFETY_AND_SECURITY_ROUND_DATA_TAG, app);
    }
    getPropsMapping() {
        return {
            freeText: 'freeText',
            marSecLevel: 'marSecLevel',
        };
    }
    createData(props) {
        return new SafetyAndSecurityRound(props.freeText, props.marSecLevel);
    }
}
//# sourceMappingURL=SafetyAndSecurityRoundParser.js.map